import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto grid grid-cols-2 gap-8" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " ID Rute ", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Nama Rute ", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Kode Rute ", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Lokasi Asal ", -1)
const _hoisted_16 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Lokasi Tujuan ", -1)
const _hoisted_18 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Jumlah Rute ", -1)
const _hoisted_20 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tipe Rute ", -1)
const _hoisted_22 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex" }
const _hoisted_23 = { class: "rounded px-2 py-0 bg-gray-lp-200" }
const _hoisted_24 = {
  key: 0,
  class: "col-span-2 border-t border-gray-lp-400 pt-8 pb-4"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-20px" }, " Informasi SLA ", -1)
const _hoisted_26 = { class: "col-span-2 pb-20" }
const _hoisted_27 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Route ", -1)
const _hoisted_30 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "capitalize" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "py-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Diubah ", -1)
const _hoisted_39 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_40 = { class: "text-gray-lp-500" }
const _hoisted_41 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_RouteOptions = _resolveComponent("RouteOptions")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailData.route_name), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.getDetail
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.detailData.id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.route_name), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.detailData.route_code), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.detailData.origin_location), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.detailData.destination), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.detailData.route_count_option) + " Opsi ", 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, _toDisplayString(_ctx.typeRoute(_ctx.detailData.route_type)), 1)
                  ])
                ]),
                (
            _ctx.detailData.route_type === 'city-city' &&
              _ctx.detailData.slaCityToCity.length
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_TableV2, {
                        class: "w-full",
                        columns: _ctx.columns,
                        data: _ctx.detailData.slaCityToCity,
                        loading: _ctx.isLoading,
                        borderTop: false,
                        borderBottom: false,
                        hidePagination: "",
                        isNoPaddingBottom: ""
                      }, null, 8, ["columns", "data", "loading"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_RouteOptions)
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.route_status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.detailData.route_status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.detailData.route_status.toLowerCase()), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDate(_ctx.detailData.created_at)), 1),
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.detailData.created_by), 1)
                ]),
                _createVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode("div", _hoisted_39, _toDisplayString(_ctx.formatDate(_ctx.detailData.updated_at || _ctx.detailData.created_at)), 1),
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.detailData.updated_by || _ctx.detailData.created_by), 1)
                ]),
                _createVNode("div", _hoisted_41, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = () => _ctx.goEdit(_ctx.id)),
                        title: "Edit",
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}